import { NgModule } from '@angular/core';
import { MailingAddressComponent } from './component/mailing-address/mailing-address.component';
import { PrimaryBusAddressComponent } from './component/primary-bus-address/primary-bus-address.component';
import { CommonFormelementsComponent } from './common-formelements.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [CommonFormelementsComponent,PrimaryBusAddressComponent,MailingAddressComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule
  ],
  exports: [CommonFormelementsComponent,PrimaryBusAddressComponent,MailingAddressComponent]
})
export class CommonFormelementsModule { }
